import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Bank } from "../api";
import { BaseResource } from "@kgsport-cms/common";
import "../common";
export var BankService = /*#__PURE__*/function (_BaseResource) {
  _inherits(BankService, _BaseResource);
  var _super = _createSuper(BankService);
  function BankService() {
    _classCallCheck(this, BankService);
    return _super.apply(this, arguments);
  }
  _createClass(BankService, [{
    key: "bindBank",
    value:
    // 绑定银行卡
    function bindBank(data) {
      return this.requester.post(Bank.bindBank, data);
    }
    // 解绑银行卡
  }, {
    key: "unBindBank",
    value: function unBindBank(id) {
      return this.requester.post("".concat(Bank.unBindBank, "/").concat(id));
    }
    // 查询银行卡列表
  }, {
    key: "bankList",
    value: function bankList(params) {
      return this.requester.get(Bank.bankList, {
        params
      });
    }
  }]);
  return BankService;
}(BaseResource);